module.exports = __webpack_public_path__ + "img/valuacion.034bc5b0.png";